import LayoutLogin from './LayoutLogin';

export default LayoutLogin;
